import React from 'react';
import ResultPageModal, { capitalizeTitle } from '../../../common/components/redesignComponents/ResultPageComponents/ResultPageModal';

function ProfessioneSanitaModal({
  insuranceRequest,
  addingQuote,
  quotations,
  selectQuotation,
  type,
  processingQuote,
}) {
  const title = type.id === 'res_civile' && insuranceRequest.product.id == 14
    ? 'Assistenza'
    : capitalizeTitle(type.name);

  return (
    <ResultPageModal
      type={type}
      title={title}
      insuranceRequest={insuranceRequest}
      addingQuote={addingQuote}
      quotations={quotations}
      selectQuotation={selectQuotation}
      processingQuote={processingQuote}
    />
  );
}

export default ProfessioneSanitaModal;
